import script from "./IconButtons.vue?vue&type=script&lang=ts&setup=true"
export * from "./IconButtons.vue?vue&type=script&lang=ts&setup=true"

import "./IconButtons.vue?vue&type=style&index=0&id=08638aec&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08638aec"]])

export default __exports__